"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAttendeeUsedBackgroundFilterSLI = void 0;
var _react = require("react");
var _react2 = require("../../client/react");
/**
 * This function tracks the background filter used for attendees
 * @param {Object} params - The parameters object
 * @param {string} params.userBackground - The background filter type used by the attendee (e.g., 'Blur', 'Custom', 'none')
 * @param {string} params.meetingUserId - The unique identifier of the user/attendee
 */
var useAttendeeUsedBackgroundFilterSLI = exports.useAttendeeUsedBackgroundFilterSLI = function useAttendeeUsedBackgroundFilterSLI(_ref) {
  var userBackground = _ref.userBackground,
    meetingUserId = _ref.meetingUserId;
  var _useBackgroundFilterP = (0, _react2.useBackgroundFilterPageActionsApi)(),
    attendeeUsedBackgroundFilter = _useBackgroundFilterP.attendeeUsedBackgroundFilter;
  (0, _react.useEffect)(function () {
    if (!meetingUserId) return;
    attendeeUsedBackgroundFilter({
      meetingUserId: meetingUserId,
      filterType: userBackground
    });
  }, [userBackground, meetingUserId]);
};